module.exports = __webpack_public_path__ + "img/driver-itinerary.4ef3b423.svg";